import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Monitor, Cctv, Globe, Server, ArrowRight } from 'lucide-react';

const SHORTCUTS = [
  { to: '/servicos-ti', icon: Wrench,  title: 'Serviços de TI', desc: 'Suporte e infraestrutura', color: 'cyan' },
  { to: '/shoficina',   icon: Monitor, title: 'SHOficina ERP',  desc: 'Sistema para oficinas',   color: 'emerald' },
  { to: '/intelbras',   icon: Cctv,    title: 'Câmeras Intelbras', desc: 'CFTV e segurança',     color: 'blue' },
  { to: '/sites',       icon: Globe,   title: 'Sites & IA',     desc: 'Criação de sites',        color: 'violet' },
  { to: '/hospedagem',  icon: Server,  title: 'Hospedagem',     desc: 'Sites e e-mails',         color: 'amber' },
];

const COLORS = {
  cyan:    { ring: 'group-hover:border-cyan-500/60',    glow: 'group-hover:shadow-cyan-500/15',    ic: 'text-cyan-400',    bg: 'bg-cyan-500/10 border-cyan-500/20' },
  emerald: { ring: 'group-hover:border-emerald-500/60', glow: 'group-hover:shadow-emerald-500/15', ic: 'text-emerald-400', bg: 'bg-emerald-500/10 border-emerald-500/20' },
  blue:    { ring: 'group-hover:border-blue-500/60',    glow: 'group-hover:shadow-blue-500/15',    ic: 'text-blue-400',    bg: 'bg-blue-500/10 border-blue-500/20' },
  violet:  { ring: 'group-hover:border-violet-500/60',  glow: 'group-hover:shadow-violet-500/15',  ic: 'text-violet-400',  bg: 'bg-violet-500/10 border-violet-500/20' },
  amber:   { ring: 'group-hover:border-amber-500/60',   glow: 'group-hover:shadow-amber-500/15',   ic: 'text-amber-400',   bg: 'bg-amber-500/10 border-amber-500/20' },
};

const QuickLinks = () => {
  return (
    <section className="bg-slate-950 py-10 border-b border-slate-800/60" data-testid="quicklinks-section" aria-label="Atalhos rápidos">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
          {SHORTCUTS.map(({ to, icon: Icon, title, desc, color }) => {
            const c = COLORS[color];
            return (
              <Link
                key={to}
                to={to}
                data-testid={`quicklink${to}`}
                className={`group relative flex flex-col items-start gap-3 p-4 sm:p-5 rounded-2xl bg-slate-900/70 border border-slate-800 ${c.ring} shadow-lg shadow-black/20 ${c.glow} transition-all duration-300 hover:-translate-y-1 overflow-hidden`}
              >
                <span className={`inline-flex items-center justify-center w-11 h-11 rounded-xl border ${c.bg}`}>
                  <Icon className={`w-5 h-5 ${c.ic}`} />
                </span>
                <span className="min-w-0">
                  <span className="block text-white font-bold text-sm sm:text-base leading-tight">{title}</span>
                  <span className="block text-slate-500 text-xs mt-0.5">{desc}</span>
                </span>
                <ArrowRight className={`absolute top-4 right-4 w-4 h-4 text-slate-700 ${c.ic.replace('text-', 'group-hover:text-')} opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all duration-300`} />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickLinks;
